import { Typography } from "antd";
import { VerificationStatus } from "./hooks/useWorldCheckVerification.hook";
import { ReactComponent as SolutionWarningIcon } from "../common/images/svg/solution-warning.svg";
import { ReactComponent as SolutionSuccessIcon } from "../common/images/svg/solution-success.svg";
import { ReactComponent as SolutionErrorIcon } from "../common/images/svg/solution-error.svg";

export function renderWorldcheckVerificationStatus(status: VerificationStatus) {
  let text;
  let icon;

  switch (status) {
    case VerificationStatus.REQUIRED:
      icon = <SolutionWarningIcon />;
      text = <Typography>Not verified.</Typography>;
      break;
    case VerificationStatus.PENDING:
      icon = <SolutionWarningIcon />;
      text = <Typography>Verification in progress </Typography>;
      break;
    case VerificationStatus.LOW_RISK:
      icon = <SolutionSuccessIcon />;
      text = <Typography style={{ color: "green" }}> Low risk.</Typography>;
      break;
    case VerificationStatus.MEDIUM_RISK:
      icon = <SolutionWarningIcon />;
      text = (
        <Typography style={{ color: "#faad14" }}> Medium risk.</Typography>
      );
      break;
    case VerificationStatus.HIGH_RISK_FIR:
      icon = <SolutionErrorIcon />;
      text = <Typography style={{ color: "red" }}> High risk (FIR)</Typography>;
      break;
    case VerificationStatus.HIGH_RISK_EDD:
      icon = <SolutionErrorIcon />;
      text = <Typography style={{ color: "red" }}> High risk (EDD)</Typography>;
      break;
  }

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
      {icon}
      <div>{text}</div>
    </div>
  );
}
